import { graphql, httpClient, resolveApiUrl } from '#shared/api'
import GetOrderListResponse from '../model/get-order-list-reponse'

interface GetOrderListOptions {
  after?: string | null
  count?: number
  address: string
  serviceIds: string[]
}

export default async function getOrderList({
  after,
  count = 20,
  address,
  serviceIds,
}: GetOrderListOptions): Promise<GetOrderListResponse['data']['ordersByStatuses']> {
  if (!address) {
    return {
      nodes: [],
      pageInfo: {
        hasNextPage: false,
        hasPreviousPage: false,
        startCursor: null,
        endCursor: null,
      },
    }
  }

  const serviceIdsVariable = '$serviceIds: [UUID!]'
  const serviceIdsFilter = `serviceIds: { some: { in: $serviceIds } }`

  const response = await httpClient.post<GetOrderListResponse>(resolveApiUrl('@sd-orders'), {
    json: graphql(
      `
        query ($count: Int!, $after: String, $address: String!, ${serviceIds.length ? serviceIdsVariable : ''}) {
          ordersByStatuses(
            first: $count
            after: $after
            where: { 
              address: { startsWith: $address }
              ${serviceIds.length ? serviceIdsFilter : ''}
            }
            order: [{ createdAt: DESC }]
          ) {
            nodes {
              address
              clientId
              id
              status
              serviceIds
              services {
                id
                workload
                template {
                  id
                  name
                }
              }
              totalReward {
                amount
                currency
              }
            }
            pageInfo {
              startCursor
              endCursor
              hasNextPage
              hasPreviousPage
            }
          }
        }
      `,
      {
        count,
        after,
        address,
        serviceIds,
      }
    ),
  })

  const responseBody = await response.json()
  return responseBody.data.ordersByStatuses
}
